'use strict'

window.LazyLoad = require('vanilla-lazyload')
require('./ready')
require('./popup')

require('./animations/header')
require('./animations/scroll-up')
